import luhnChecker from './luhnChecker';

const JCB = /\s*(?:(?:2\s*1\s*3\s*1\s*|1\s*8\s*0\s*0\s*|3\s*5\s*\d\s*\d\s*\d\s*)\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*)/;
const DINERS_CLUB = /\s*(?:3\s*(?:0\s*[0-5]\s*|[68]\s*[0-9]\s*)[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*)/;
const AMEX = /\s*(?:3\s*[47]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*)/;
const VISA = /\s*(?:4\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*)(?:[0-9]\s*)?/;
const MAESTRO = /\s*(?:(?:5\s*[0678]\s*\d\s*\d\s*|6\s*3\s*0\s*4\s*|6\s*3\s*9\s*0\s*|6\s*7\s*\d\s*\d\s*)[\d|\d\s*]{12,30}\s*)/;
const MASTERCARD = /\s*(?:(?:5\s*[1-5]\s*[0-9]\s*[0-9]\s*|2\s*2\s*2\s*[1-9]\s*|2\s*2\s*[3-9]\s*[0-9]\s*|2\s*[3-6]\s*[0-9]\s*[0-9]\s*|2\s*7\s*[01]\s*[0-9]\s*|2\s*7\s*2\s*0\s*)[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*)/;
const DISCOVER = /\s*(?:6\s*(?:0\s*1\s*1\s*|5\s*[0-9]\s*[0-9]\s*)(?:[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*))/;

const cardRegexArray = [JCB, DINERS_CLUB, AMEX, VISA, MAESTRO, MASTERCARD, DISCOVER];
const cardRegexPattern = new RegExp(cardRegexArray.map(reg => reg.source).join('|'));

const containsLuhnCheckedNumber = fieldName => (value) => {
  if (!value) return;
  if (value.length >= 11 && cardRegexPattern.test(value)) {
    const matchedValue = value.match(cardRegexPattern)[0];
    
    return luhnChecker(matchedValue) ? `errors.formFields.containsCardNumber.${fieldName}` : undefined;
  }
};

export default containsLuhnCheckedNumber;
